<template>
    <div class="app flex-row align-items-center">
        <div class="container">
            <b-row class="justify-content-center">
                <b-col md="8">
                    <b-card-group>
                        <b-card no-body class="p-4">
                            <b-card-body>
                                <b-form @submit.prevent="passwordReset">
                                    <h3 class="mb-4">Wachtwoord instellen</h3>
                                    <b-input-group class="mb-3">
                                        <b-input-group-prepend><b-input-group-text><i class="icon-user"></i></b-input-group-text></b-input-group-prepend>
                                        <b-form-input type="email" class="form-control" placeholder="E-mail" v-model="form.email" disabled />
                                    </b-input-group>
                                    <b-input-group class="mb-3">
                                        <b-input-group-prepend><b-input-group-text><i class="icon-lock"></i></b-input-group-text></b-input-group-prepend>
                                        <b-form-input type="password" class="form-control" placeholder="Wachtwoord" v-model="form.password" required />
                                    </b-input-group>
                                    <b-input-group class="mb-3">
                                        <b-input-group-prepend><b-input-group-text><i class="icon-lock"></i></b-input-group-text></b-input-group-prepend>
                                        <b-form-input type="password" class="form-control" placeholder="Bevestig wachtwoord" v-model="form.password_confirmation" required />
                                    </b-input-group>
                                    <div v-if="loading" class="container-loading mb-3">
                                        <img src="/img/loading.gif" alt="Loading Icon" height="50px">
                                    </div>
                                    <p v-if="message" class="text-danger">{{ message }}</p>
                                    <b-row>
                                        <b-col cols="12">
                                            <b-button variant="primary" class="px-4 mt-2" type="submit">Wachtwoord instellen</b-button>
                                        </b-col>
                                    </b-row>
                                </b-form>
                            </b-card-body>
                        </b-card>
                        <b-card bg-variant="dark"  class="d-md-down-none d-flex align-items-center" style="background-image: url('/img/realiance-sfeer.jpg'); background-repeat: no-repeat; background-size: 150% auto; background-position: center;"></b-card>
                    </b-card-group>
                </b-col>
            </b-row>
        </div>
    </div>
</template>

<script>
    import axios from 'axios';
    import {addData} from "@/api";

    export default {
        name: 'password-reset',
        data() {
            return {
                form: {
                    email: this.$route.query.email,
                    password: null,
                    password_confirmation: null,
                    token: this.$route.query.token,
                },
                message: null,
                success: false,
                loading: false,
            }
        },
        methods: {
            async passwordReset() {
                this.loading = true;
                const request = await addData('auth/reset-password', this.form).then(response => response);
                if (request.status !== 202) {
                    this.message = 'Er is iets misgegaan. Zeker dat alles klopt?';
                    this.loading = false;
                } else {
                    alert('Gelukt! We verwijzen je nu door naar de login pagina.');
                    this.$router.push('login');
                }
            }
        },
    }
</script>
